import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { StorageService } from '../../core/services/storage.service';

export const SUPPORTED_LANGUAGES = ['en'] as const;
const DEFAULT_LANGUAGE = 'en';

@Injectable()
export class LanguageService {
  private currentLanguage: string;
  private languageChanges = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private storageService: StorageService
  ) {
    this.currentLanguage = this.detectUserLanguage();
    translateService.setDefaultLang(DEFAULT_LANGUAGE);
    translateService.use(this.getCurrentLanguage());
  }

  private detectUserLanguage(): string {
    const savedLanguage = this.storageService.getUiLanguage();
    if (savedLanguage) {
      return savedLanguage;
    }

    const navigatorLanguage = this.translateService.getBrowserLang();
    if (SUPPORTED_LANGUAGES.includes(navigatorLanguage as any)) {
      return navigatorLanguage!;
    }
    return DEFAULT_LANGUAGE;
  }

  getCurrentLanguage() {
    return SUPPORTED_LANGUAGES.includes(
      this.currentLanguage as (typeof SUPPORTED_LANGUAGES)[number]
    )
      ? this.currentLanguage
      : SUPPORTED_LANGUAGES[0];
  }

  setCurrentLanguage(lang: string) {
    this.storageService.setUiLanguage(lang);
    this.currentLanguage = lang;
    this.translateService.use(lang);
    this.languageChanges.next();
  }
}
